/* lib/reports/abcMeta.js — реестр приоритетов и статусов food cost
 * ABC-анализа v2. id ОБЯЗАНЫ байт-в-байт совпадать с бэкендом
 * (backend/reports/abc_calc.py PRIORITIES / FC_STATUSES) — это ключи
 * priority/fc_status в Report.result и фильтра таблицы по кликабельным тегам. */

export const ABC_PRIORITY = {
  p1: {
    label: 'Приоритет 1', short: 'P1', tone: 'bad', icon: 'alert-circle',
    title: 'A по продажам и food cost > 20 % — каждый процент FC на топовых продажах стоит дорого',
  },
  p2: {
    label: 'Приоритет 2', short: 'P2', tone: 'bad', icon: 'alert-triangle',
    title: 'BCC/CCC (кандидаты на вывод) или food cost ≥ 30 %',
  },
  p3: {
    label: 'Приоритет 3', short: 'P3', tone: 'warn', icon: 'minus',
    title: 'Просадка по прибыли или food cost 20–30 %',
  },
  potential: {
    label: 'Потенциал', short: 'Потенциал', tone: 'info', icon: 'arrow-up-right',
    title: 'Низкий food cost и B по продажам/выручке — можно усиливать продажи',
  },
  normal: {
    label: 'Норма', short: 'Норма', tone: 'ok', icon: 'check',
    title: 'Стабильные позиции без явных проблем',
  },
};
// порядок сортировки/вывода тегов (зеркало бэкенд-PRIORITIES)
export const ABC_PRIORITY_ORDER = ['p1', 'p2', 'p3', 'potential', 'normal'];

export const ABC_FC_STATUS = {
  no_data: {
    label: 'нет ТТК', tone: 'neutral', icon: 'minus',
    title: 'Food cost 0 % или отсутствует — нет ТТК или некорректные данные',
  },
  good: {
    label: 'в норме', tone: 'ok', icon: 'check',
    title: 'Food cost < 20 % — в пределах нормы',
  },
  above_target: {
    label: 'выше цели', tone: 'warn', icon: 'alert-triangle',
    title: 'Food cost 20–25 % — выше целевого уровня',
  },
  critical: {
    label: 'критично', tone: 'bad', icon: 'alert-circle',
    title: 'Food cost 25–30 % — критический уровень',
  },
  urgent: {
    label: 'срочно', tone: 'bad', icon: 'alert-circle',
    title: 'Food cost ≥ 30 % — срочно оптимизировать',
  },
};
export const ABC_FC_ORDER = ['urgent', 'critical', 'above_target', 'good', 'no_data'];

export const abcPrio = (id) => ABC_PRIORITY[id] || ABC_PRIORITY.normal;
export const abcFc = (id) => ABC_FC_STATUS[id] || ABC_FC_STATUS.no_data;

/* Границы класса СЛОВАМИ — «критично» само по себе не говорит, где проходит
   граница, и узнать это можно было только наведением мыши (title). На карточках
   A/B/C диапазон подписан прямо («0–70 %»), а у food cost его не было вовсе:
   пять карточек с числами без единой подписи. Строится из FC_THRESHOLDS, то есть
   расходиться со шкалой не может. */
export function fcRange(id) {
  const { good, above_target: above, critical } = FC_THRESHOLDS;
  switch (id) {
    case 'good': return 'до ' + good + ' %';
    case 'above_target': return good + '–' + above + ' %';
    case 'critical': return above + '–' + critical + ' %';
    case 'urgent': return 'от ' + critical + ' %';
    default: return '';       // no_data — диапазона нет, класс не про проценты
  }
}

// Пороговая шкала food cost, % — зеркало backend/reports/abc_calc.py
// (FC_GOOD_MAX / FC_ABOVE_MAX / FC_CRITICAL_MAX + fc_status()). Нужна фронту
// ТОЛЬКО для клиентских агрегатов (группы/итоги), где бэкенд статус не отдаёт;
// статусы позиций всегда берём готовыми из ответа бэкенда.
export const FC_THRESHOLDS = { good: 20, above_target: 25, critical: 30 };
export function fcStatusOf(pct) {
  if (pct == null || pct <= 0) return 'no_data';
  if (pct < FC_THRESHOLDS.good) return 'good';
  if (pct < FC_THRESHOLDS.above_target) return 'above_target';
  if (pct < FC_THRESHOLDS.critical) return 'critical';
  return 'urgent';
}
